<template>
  <div>
    <div class="w-full rounded-2xl">
      <div class="w-full bg-orange-500">
        <div
          class="max-w-7xl w-full h-16 mx-auto flex items-center justify-center text-white text-center gap-x-2 md:gap-x-8 py-2 px-2 md:px-0"
        >
          <div class="text-xs">
            Gerçek Kullanıcılarla Sosyal Medya Etkileşimlerinizi Hemen Arttırın.
          </div>
          <NuxtLink to="/register">
            <div
              class="bg-orange-400 text-white rounded text-xs text-nowrap px-3 py-2"
            >
              Kayıt Ol
            </div>
          </NuxtLink>
        </div>
      </div>
      <LandingHeader />
      <IncreaseYourInteraction />
      <BeatTheAlgorithms />

      <SliderBrands />
      <LandingPage
        :imageUrl="'/img/landing/360-sosyal-nedir.png'"
        title="360 Sosyal Nedir?"
        imageAlt="360 Sosyal Nedir?"
        :texts="what360SocialTexts"
      />
      <LandingPage
        class="bg-white"
        :imageUrl="'/img/landing/neden-360-sosyal.png'"
        title="Neden 360Sosyal?"
        imageAlt="Neden 360Sosyal?"
        :texts="why360SocialTexts"
        :reverse="true"
      />
      <WhatDoesPromise />
      <FlexibleService />
      <CustomerComments />
      <Faq />
      <Social360AndOthers />
      <LandingFooter />
    </div>
  </div>
</template>

<script lang="ts" setup>
import BeatTheAlgorithms from "./components/BeatTheAlgorithms.vue";
import CustomerComments from "./components/CustomerComments.vue";
import Faq from "./components/Faq.vue";
import FlexibleService from "./components/FlexibleService.vue";
import IncreaseYourInteraction from "./components/IncreaseYourInteraction.vue"; /* PartiallyEnd: #3632/scriptSetup.vue */
import LandingPage from "./components/LandingPage.vue";
import SliderBrands from "./components/SliderBrands.vue";
import Social360AndOthers from "./components/Social360AndOthers.vue";
import WhatDoesPromise from "./components/WhatDoesPromise.vue";

const what360SocialTexts = ref([
  "360Sosyal, sosyal medya platformlarında gerçek kullanıcılarla etkileşim sağlayarak içeriklerin daha fazla kişiye ulaşmasını ve organik büyümenin desteklenmesini amaçlayan bir sistemdir.",
  "Çoğu hizmet sahte veya pasif hesaplarla geçici sonuçlar sunarken, 360Sosyal algoritmaya uyumlu etkileşimlerle kalıcı büyüme sağlar.",
])
const why360SocialTexts = ref([
  "Sosyal medya platformları, içerikleri yalnızca sayılara göre değil, gerçek kullanıcı etkileşimlerine göre değerlendirir. ",
  "Algoritma tarafından öne çıkarılmak ve doğal bir keşfedilirlik sağlamak için aktif ve organik bir topluluk oluşturmak gerekir. 360Sosyal, tam olarak bunu yaparak hesabınızı hedef kitlenizle daha sık buluşturur.",
])
</script>

<style>
.text-landing-orange {
  color: #f97316;
}
</style>
